export const EXPANDED_SIDEBAR_WIDTH = 210;
export const COLLAPSED_SIDEBAR_WIDTH = 61;
